var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.product.tier_prices),function(tierPrice){return _c('li',{key:tierPrice.qty},[_vm._v(" Kaufen Sie "+_vm._s(tierPrice.qty)+" zum Preis von je "),_c('strong',[_vm._v(_vm._s(_vm._f("price")(tierPrice.value)))]),_vm._v(" und "),_c('strong',[_vm._v("sparen Sie "+_vm._s(_vm.percent(tierPrice.value))+"%")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }